import moment from 'moment'
import 'moment/locale/pt-br'

const dateLocaleFormat = (date, format) => {
  return moment(date).format(format)
}

export default dateLocaleFormat
